import * as Sentry from '@sentry/vue';

export default function initSentry(app: any, deployEnv: string, name: string, component: string) {
    Sentry.init({
        app,
        dsn: 'https://e86bb6fa3b8e214c88aa04fef2a29d19@o161782.ingest.us.sentry.io/4509718095790081',
        environment: deployEnv,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 1.0,

        // Filter out errors that aren't related to our components
        beforeSend(event) {
            // Check if error originates from our component files
            const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];

            const isComponentError = frames.some((frame) => {
                const filename = frame.filename || '';
                return (
                    filename.includes(name) ||
                    filename.includes('vue-widgets.energysage') ||
                    frame.function?.includes(component)
                );
            });

            if (!isComponentError) {
                return null; // Drop non-component errors
            }

            // Add component identification for better grouping
            // eslint-disable-next-line no-param-reassign
            event.tags = {
                ...event.tags,
                component: name,
                host_domain: window?.location?.hostname,
            };

            return event;
        },
    });
}
